import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopMenuComponent } from '../../components/top-menu/top-menu.component';
import { BottomMenuComponent } from '../../components/bottom-menu/bottom-menu.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/shared/modules/app/app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { TopMenuTwoComponent } from '../../components/top-menu-two/top-menu-two.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { SideBarComponent } from '../../components/side-bar/side-bar.component';
import { SharedModule } from '../shared/shared.module';

const components = [
  LayoutComponent,
  TopMenuComponent,
  BottomMenuComponent,
  TopMenuTwoComponent,
  SideBarComponent,
]

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgScrollbarModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule
  ],
  exports: components
})
export class LayoutModule { }
